/** Pure participant helpers for the manager room (P5.1 §C). Kept free of React / livekit-client so they
 * unit-test without a browser. */

/** The LiveKit job worker joins the room as a `agent-<id>` participant (e.g. `agent-AJ_xxx`) with no
 * useful media — it should be hidden from the manager's tile grid. The LiveAvatar participant uses a
 * different identity (`liveavatar-avatar-agent`) and publishes the avatar video, so it is NOT matched
 * here and stays visible. Match by identity prefix (not participant kind): the avatar may also report an
 * Agent kind, so a kind-based filter would wrongly drop it. */
export function isWorkerIdentity(identity: string): boolean {
  return identity.startsWith("agent-");
}
